export interface StatItem {
  label: string;
  value: string;
  suffix: string;
}

export interface MilestoneItem {
  year: string;
  title: string;
  description: string;
}

export const aboutStats: StatItem[] = [
  { label: '日均活跃用户', value: '5000', suffix: '万+' },
  { label: '视频资源总量', value: '100', suffix: '万+' },
  { label: '累计播放时长', value: '800', suffix: '亿小时' },
  { label: '用户好评率', value: '98.5', suffix: '%' },
];

export const milestones: MilestoneItem[] = [
  { year: '2018', title: '平台创立', description: '91视频在线观看正式上线，以"让每个人都能免费看好视频"为使命，开启了高清视频播放的新纪元。' },
  { year: '2019', title: '用户突破千万', description: '凭借流畅的播放体验和丰富的内容资源，平台注册用户突破1000万，月活跃用户超过3000万。' },
  { year: '2020', title: '4K超高清上线', description: '全面升级视频编码技术，率先支持4K超高清画质播放，成为业内画质标杆。' },
  { year: '2021', title: '内容生态完善', description: '引入海量正版影视资源，覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容。' },
  { year: '2022', title: 'AI智能推荐', description: '推出基于深度学习的智能推荐系统，为用户精准匹配感兴趣的视频内容，用户满意度大幅提升。' },
  { year: '2023', title: '全球化布局', description: '启动海外业务，服务覆盖东南亚、北美、欧洲等地区，支持多语言界面和字幕。' },
  { year: '2024', title: '技术创新突破', description: '自研P2P-CDN混合加速技术，带宽成本降低40%，用户加载速度提升60%。' },
  { year: '2025', title: '生态开放平台', description: '推出创作者开放平台，吸引超过50万内容创作者入驻，日均上传视频超过10万条。' },
  { year: '2026', title: 'AI赋能新时代', description: '全面拥抱AI技术，推出AI字幕、AI配音、AI内容审核等创新功能，开启智慧视频新纪元。' },
];

export const testimonials: { name: string; role: string; content: string; rating: number }[] = [
  { name: '王先生', role: '资深影迷', content: '用了三年了，画质越来越好，加载速度也快。最重要的是免费！推荐给身边所有朋友了。', rating: 5 },
  { name: '李女士', role: '全职妈妈', content: '孩子特别喜欢在91视频上看动画片，种类多还没有广告，做家务的时候给孩子看很放心。', rating: 5 },
  { name: '张同学', role: '大学生', content: '追剧神器！更新速度和画质都没得说，宿舍四个人都在用，周末一起看电影太爽了。', rating: 5 },
  { name: '陈先生', role: 'IT工程师', content: '从技术角度看，91视频的P2P加速技术确实厉害，在弱网环境下也能流畅播放，技术实力很强。', rating: 4 },
  { name: '刘女士', role: '自媒体博主', content: '作为内容创作者，91视频给了我很大的展示平台，收益也不错，会继续在这里创作。', rating: 5 },
  { name: '赵先生', role: '退休教师', content: '界面简洁好用，字体大小合适，我们老年人操作起来也方便。纪录片资源很丰富，每天必看。', rating: 5 },
];

export const contactInfo = {
  email: 'service@91video.com',
  phone: '400-888-9191',
  address: '北京市海淀区中关村科技园区创新路88号',
  workingHours: '周一至周日 9:00 - 21:00',
};